/**
 * Public monitoring gates for SafeGeo Admin SPA (Vite).
 * All keys are VITE_* - baked at build; never put auth tokens here.
 */

function flag(v: unknown, defaultOn = false): boolean {
  if (v === undefined || v === "") return defaultOn;
  const s = String(v).toLowerCase();
  if (s === "false" || s === "0" || s === "off") return false;
  if (s === "true" || s === "1" || s === "on") return true;
  return defaultOn;
}

export type MonitoringConfig = {
  product: "safegeo";
  appHandle: string;
  ga4: { enabled: boolean; measurementId: string };
  clarity: { enabled: boolean; projectId: string };
  posthog: {
    enabled: boolean;
    key: string;
    host: string;
    projectId: string;
  };
  crisp: { enabled: boolean; websiteId: string };
};

export function getMonitoringConfig(): MonitoringConfig {
  const gaId = (import.meta.env.VITE_GA_MEASUREMENT_ID || "").trim();
  const clarityId = (import.meta.env.VITE_CLARITY_PROJECT_ID || "").trim();
  const phKey = (import.meta.env.VITE_POSTHOG_KEY || "").trim();
  const crispId = (import.meta.env.VITE_CRISP_WEBSITE_ID || "").trim();

  return {
    product: "safegeo",
    appHandle: (
      import.meta.env.VITE_SHOPIFY_APP_HANDLE || "safegeo"
    ).trim(),
    ga4: {
      enabled: flag(import.meta.env.VITE_GA_ENABLED, !!gaId) && !!gaId,
      measurementId: gaId,
    },
    clarity: {
      enabled:
        flag(import.meta.env.VITE_CLARITY_ENABLED, !!clarityId) && !!clarityId,
      projectId: clarityId,
    },
    posthog: {
      enabled: flag(import.meta.env.VITE_POSTHOG_ENABLED, !!phKey) && !!phKey,
      key: phKey,
      host: (
        import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com"
      ).trim(),
      projectId: (import.meta.env.VITE_POSTHOG_PROJECT_ID || "").trim(),
    },
    crisp: {
      enabled: flag(import.meta.env.VITE_CRISP_ENABLED, !!crispId) && !!crispId,
      websiteId: crispId,
    },
  };
}
